import img1 from "./WhatsApp Image 2025-11-27 at 9.40.17 AM (1).jpeg";
import img2 from "./WhatsApp Image 2025-11-27 at 9.40.17 AM.jpeg";
import img3 from "./WhatsApp Image 2025-11-27 at 9.40.18 AM (1).jpeg";
import img4 from "./WhatsApp Image 2025-11-27 at 9.40.18 AM (2).jpeg";
import img5 from "./WhatsApp Image 2025-11-27 at 9.40.18 AM.jpeg";

export default [
  img1,
  img2,
  img3,
  img4,
  img5,
];
